import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Layout, Row, Col, Button, Upload, notification, Modal, Tooltip, Icon } from 'antd'
import { TextareaItem } from 'antd-mobile'
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { withTranslation } from 'react-i18next'
import Format from '../../utils/format'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Linkify from 'react-linkify';
import MicRecorder from 'mic-recorder-to-mp3';
import { v4 } from 'uuid';
import Toast from 'antd-mobile/lib/toast';

import './chatPage.css'
import sendIcon from '../../assets/image/Send.png'
import downloadIcon from '../../assets/image/download.svg'
import keyboardIcon from '../../assets/image/keyboard.png'
import voiceIcon from '../../assets/image/voice-command.png'

const { Content } = Layout
const messagesEndRef = React.createRef()
const STAYCHAT_API_URL = process.env.REACT_APP_STAYCHAT_API
const isDisableBot = process.env.REACT_APP_STAYCHAT_BOT_DISABLE !== "false"
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

@inject(
    'webSettingStore',
    'chatStore'
)
@observer
class ChatPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isRecording: false,
            isBlocked: false,
            isTextInput: true,
            recordButtonClass: '',
            recordButtonWidth: '40px',
            recordButtonHeight: '40px'
        }
    }

    componentDidMount() {
        this.props.webSettingStore.getData();
        navigator.mediaDevices.getUserMedia({ audio: true },
            () => {
                console.log('Mic Permission Granted');
                this.setState({ isBlocked: false });
            },
            () => {
                console.log('Mic Permission Denied');
                this.setState({ isBlocked: true });
            },
        );

        if (process.env.REACT_APP_STAYCHAT_API) this.props.chatStore.load()
        this.scrollToBottom()
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    setMessage = (e) => {
        this.props.chatStore.setMessage(e)
    }

    setCurrentImage = (e) => {
        this.props.chatStore.setCurrentImage(e)
    }

    setIsViewerOpen = (e) => {
        this.props.chatStore.setIsViewerOpen(e)
    }

    openImageViewer = (image) => {
        this.setCurrentImage(image);
        this.setIsViewerOpen(true);
    }

    closeImageViewer = () => {
        this.setIsViewerOpen(false);
    }

    handleInputToggle = () => {
        const inputToggleValue = !this.state.isTextInput;
        this.setState({ isTextInput: inputToggleValue });
    }

    handleSendMessage = () => {
        const { loading, message } = this.props.chatStore;
        if (loading || !message) return;

        this.props.chatStore.setKeepLoading(!isDisableBot);
        this.props.chatStore.send().then(() => {
            this.props.chatStore.load();
        })
    }

    sendWithMessage = (request) => {
        this.props.chatStore.setMessage(request);
        const { loading, message } = this.props.chatStore;
        if (loading || !message) return;

        this.props.chatStore.setKeepLoading(!isDisableBot);
        this.props.chatStore.send().then(() => {
            this.props.chatStore.load();
        });
    }

    // ON UPLOAD

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file) => {
        const isLessThan10Mb = file.size / 1024 / 1024 < 10;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 10MB!',
                placement: 'bottomRight',
            });
        }

        return isLessThan10Mb;
    }

    handleSendFile = (info) => {
        if (!info.file.status || info.file.status !== 'done') return;

        this.props.chatStore.sendFile(info.file.originFileObj).then(() => {
            this.props.chatStore.load();
        })
    }

    getMediaElement(content, fileName, mediaType, s3FilePath, isLastIndex) {
        const fileUrl = s3FilePath ? `${STAYCHAT_API_URL}/staymenuchats/getfile?fileUrl=` + encodeURIComponent(s3FilePath) : `${STAYCHAT_API_URL}/whatsapp/file/${content}`;

        const image = <img src={fileUrl} onClick={() => this.openImageViewer(fileUrl)} style={{ maxWidth: '100%' }} alt=""></img>;
        const video = <video controls style={{ maxWidth: '100%' }}><source src={fileUrl}></source>Your browser does not support HTML video.</video>;
        const document = <a className='ant-btn' href={fileUrl} style={{ maxWidth: '100%', whiteSpace: 'pre-wrap', height: 'auto' }}>{fileName}</a>;

        switch (mediaType) {
            case "image": return image;
            case "video": return video;
            case "document": return document;
            default: return this.getGptBaseMessage(content, isLastIndex);
        }
    }

    getGptBaseMessage(message, isLastIndex) {
        if (!message) return <></>;

        const { loading } = this.props.chatStore;
        const isConfirmation = message.includes("isConfirmation:true") || message.includes("isConfirmation: true");

        if (message.includes("|||")) {
            const stringFromApiSplit = message.split("|||");
            if (stringFromApiSplit.length > 0) {
                message = stringFromApiSplit[0];
            }
        }

        return (
            <>
                <div>
                    <p>
                        <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (
                            <a rel='noopener noreferrer' target="_blank" href={decoratedHref} key={key}>{decoratedText}</a>)}>
                            {message}
                        </Linkify>
                    </p>
                </div>
                <>
                    {
                        isConfirmation && isLastIndex
                            ?
                            <div className='chatpage-div-button'>
                                <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.sendWithMessage('Yes')}>Yes</Button>
                                <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.sendWithMessage('No')}>No</Button>
                                <Button className='chatpage-button-action-inline-outlined' disabled={loading} onClick={() => this.sendWithMessage('Cancel')}>Cancel</Button>
                            </div>
                            :
                            null
                    }
                </>
            </>
        );
    }

    renderChatDetail = (chat, isLastIndex) => {
        return (
            chat.creater === 'Admin' ? (
                <Row>
                    <Col span={3} className='mg-t-5 mg-b-5 pd-l-10 txt-algn-center'>
                        <AccountCircleIcon style={{ color: '#C4A56B', fontSize: 32 }} />
                    </Col>
                    <Col span={16} className='col-body-content-chat-detail col-body-content-chat-detail-admin'>
                        <Row>
                            <Col span={20} className="font-arial-14 chat-pre-wrap">
                                {this.getMediaElement(chat.content, chat.fileName, chat.mediaType, chat.s3FilePath, isLastIndex)}
                                {
                                    chat.audioUrl ?
                                        <div>
                                            <audio className='sc-audio' src={chat.audioUrl} controls controlsList='noplaybackrate nodownload nofullscreen'></audio>
                                        </div> :
                                        null
                                }
                            </Col>
                            <Col span={4} className='col-body-content-chat-detail-time'>
                                {Format.TimeLocalOnly(chat.createTime)}
                            </Col>
                        </Row>
                    </Col>
                    <Col span={5} />
                </Row>
            ) : (
                <Row>
                    <Col span={5} />
                    <Col span={18} className='col-body-content-chat-detail col-body-content-chat-detail-guest'>
                        <Row>
                            <Col span={20} className="font-arial-14 chat-pre-wrap">
                                {this.getMediaElement(chat.content, chat.fileName, chat.mediaType, chat.s3FilePath)}
                            </Col>
                            <Col span={4} className='col-body-content-chat-detail-time'>
                                {Format.TimeLocalOnly(chat.createTime)}
                            </Col>
                        </Row>
                    </Col>
                    <Col span={1} />
                </Row>
            )
        )
    }

    renderNoDetail = (chat) => {
        return null; //(<React.Fragment key={chat.chatId}></React.Fragment>)
    }

    scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: 'auto' })
    }

    startRecording = (e) => {
        if (this.state.isBlocked) {
            console.log('Mic Permission Denied');
        } else {
            console.log("Recording started");

            this.setState({ recordButtonWidth: '45px' });
            this.setState({ recordButtonHeight: '45px' });
            this.setState({ recordButtonClass: 'blink-button' });

            Mp3Recorder
                .start()
                .then(() => {
                    this.setState({ isRecording: true });
                }).catch((e) => console.error(e));
        }
    }

    endRecording = (e) => {
        console.log("Recording ended");

        this.setState({ recordButtonWidth: '40px' });
        this.setState({ recordButtonHeight: '40px' });
        this.setState({ recordButtonClass: '' });

        Mp3Recorder
            .stop()
            .getMp3()
            .then(([buffer, blob]) => {
                if (!buffer || !blob?.size || blob.size < 5000) {
                    console.log(`Audio size is too small (${blob?.size}), please try again.`);
                    return;
                }

                const file = new File(buffer, `${v4()}.mp3`, {
                    type: blob.type,
                    lastModified: Date.now()
                });

                this.props.chatStore.setKeepLoading(!isDisableBot);
                this.props.chatStore.sendVoice(file).then(() => {
                    this.props.chatStore.load();
                });
            }).catch((e) => console.log(e));
    }

    renderChatDate = (chat) => {
        return (
            chat.showDate ? (<Row>
                <Col span={9} />
                <Col span={6} className='col-body-content-chat-detail-date'>
                    {Format.DateLocalOnly(chat.createTime)}
                </Col>
                <Col span={9} />
            </Row>) : (
                <React.Fragment></React.Fragment>
            )
        )
    }

    render() {
        const {
            data: webSettting
        } = this.props.webSettingStore;

        const showHeaderFooter = localStorage.getItem('showHeaderFooter')
        const { message, chatList, currentImage, isViewerOpen, loading } = this.props.chatStore;

        const Typing = () => (
            <div className="typing">
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
            </div>
        );

        return (
            <Layout className='bg-white height-all bg-clr-dark-2'>
                <Content>
                    <Row className={showHeaderFooter === 'true' ? 'mg-t-60 pd-b-100 bg-clr-dark-2' : 'mg-t-60 pd-b-100 bg-clr-dark-2'}>
                        {
                            chatList.map((chat, index) => {
                                let isLastIndex = index >= chatList.length - 1;
                                return !chat.content ? (
                                    this.renderNoDetail(chat)
                                ) : (
                                    <React.Fragment key={chat.chatId}>
                                        {this.renderChatDate(chat)}
                                        {this.renderChatDetail(chat, isLastIndex)}
                                    </React.Fragment>
                                )
                            })
                        }
                    </Row>
                    <div ref={messagesEndRef} />
                    <Row>
                        <Col span={24} className={showHeaderFooter === 'true' ? 'col-body-content-chat-control' : 'col-body-content-chat-control-nofooter'}>
                            <div> {loading ? <Typing /> : null} </div>
                            <Row>
                                <Col span={isDisableBot ? 2 : 4} className='txt-algn-center pd-t-4' style={{ display: 'flex', marginTop: '6px' }}>
                                    <Upload
                                        className='needsclick'
                                        accept='image/jpeg,image/png,video/mp4,video/3gpp,.mov,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf'
                                        customRequest={this.dummyRequest}
                                        beforeUpload={this.beforeUpload}
                                        multiple={false}
                                        showUploadList={false}
                                        onChange={(info) => this.handleSendFile(info)}
                                    >
                                        <AttachFileIcon style={{ opacity: '0.5' }} />
                                    </Upload>
                                    {
                                        isDisableBot ? <></> :
                                            <div onClick={this.handleInputToggle} style={{ marginLeft: '7.5px' }}>
                                                <img src={this.state.isTextInput ? voiceIcon : keyboardIcon} alt='Input Toggle' className='img-chat-control-icon-send' />
                                            </div>
                                    }
                                </Col>
                                <Col span={isDisableBot ? 22 : 20}>
                                    {
                                        this.state.isTextInput ?
                                            <Row>
                                                <Col span={21}>
                                                    <TextareaItem
                                                        placeholder={webSettting ? webSettting.sendMessageText : 'Send message'}
                                                        className='input-message'
                                                        autoHeight
                                                        value={message}
                                                        onChange={this.setMessage}
                                                    />
                                                </Col>
                                                <Col span={3} className='txt-algn-center pd-t-4' onClick={this.handleSendMessage} style={{ marginTop: '6px' }}>
                                                    <img src={sendIcon} alt='Mic' className='img-chat-control-icon-send' />
                                                </Col>
                                            </Row> :
                                            <Row>
                                                <Col style={{ display: 'flex', justifyContent: 'center', margin: '2px 0' }}>
                                                    <Tooltip title="Hold to record, release to send">
                                                        <Button className={this.state.recordButtonClass} style={{ width: this.state.recordButtonWidth, height: this.state.recordButtonHeight }} type="primary" shape="circle" onMouseDown={(e) => this.startRecording(e)} onTouchStart={(e) => this.startRecording(e)} onMouseUp={(e) => this.endRecording(e)} onTouchEnd={(e) => this.endRecording(e)}>
                                                            <Icon type='audio' style={{ fontSize: '150%' }} />
                                                        </Button>
                                                    </Tooltip>
                                                </Col>
                                            </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {
                        <Modal
                            visible={isViewerOpen}
                            onCancel={this.closeImageViewer}
                            footer={[
                                <a className='ant-btn' href={currentImage} style={{ color: '#8c8c8c', borderColor: '#8c8c8c' }}>
                                    <embed src={downloadIcon} style={{ maxHeight: '0.75em', paddingRight: '0.25em' }} />
                                    Download
                                </a>
                            ]}
                            wrapClassName='stm-modal-center-footer'
                            bodyStyle={{ height: '75vh' }}
                            title={null}
                        >
                            <TransformWrapper>
                                <TransformComponent wrapperStyle={{ height: '100%' }}>
                                    <img src={currentImage} style={{ maxWidth: '100%' }} alt=""></img>
                                </TransformComponent>
                            </TransformWrapper>
                        </Modal>
                    }
                </Content>
            </Layout>
        )
    }
}

export default withTranslation()(ChatPage)
